<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">句式：</span>
                <a-input placeholder="请输入句式" class="seachs" v-model="seach.keyword"/>
            </div>
            <div class="seachList  ">
                <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                    查询
                </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>
        <a-button class="top_btn" type="primary" @click="()=>{  visible = true; title='添加阶段报告' }"  > 添加
        </a-button>
      <p style="color: #f00">注：指令中需包含关键词，用{keyword}表示；包含关键词排名，用{ranking}表示；需包含自然流量表现，用{natural_flow}表示；需包含关键词排名变化，用{keyword_ranking}表示；需包含页面收录数量，用{page_inclusion}表示；</p>

      <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" >
            <span slot="status" slot-scope="text, record">
                <a-switch @click="onChange(record)" :checked="text==1?true:false" />
            </span>
            <span slot="action" slot-scope="text, record">
                <a @click="(record)=>{visible = true;  title='编辑阶段报告'; editId=text.id ; }" >编辑</a>
            </span>
        </a-table>
        <a-pagination
            :current="pagination.current"
            :total="pagination.total"
            :pageSize="pagination.pageSize"
            :showSizeChanger="true"
            :showQuickJumper="true"
            :showTotal="(total, range) => `共 ${total} 条`"
            @change="getList"
            @showSizeChange="onShowSizeChange"
            style="margin-top: 20px; text-align: right;"
        />
        <InstructionForm :visible="visible" :title="title" :editId="editId"
                         @changVisible=" () => { this.visible = false;this.editId=''; this.getList()}  "/>
    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import InstructionForm from "./components/instructionForm"
    import {changStatus} from "../../../../utils/utils"
    const columns = [
        {
            title: "序号",
            dataIndex: "id",
            key: "id",
            width: "100px",
        },
        {
            title: "指令词",
            dataIndex: "ai_prompt",
            ellipsis: true,
            key: "ai_prompt"
        },
        {
            title: "状态",
            key: "status",
            width: "150px",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "添加时间",
            dataIndex: "create_time",
            key: "create_time",
            width: "180px",
        },
        {
            title: "修改时间",
            dataIndex: "update_time",
            key: "update_time",
            width: "180px",
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "phaseReport",
        data() {
            return {
                seach: {
                    keyword: "",
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20,
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize),
                    onChange: this.getList.bind(this),
                    total: 0,
                    current: 1,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/ai/aiReport/phaseReport";
        },
        mounted() {
            this.getList()
        },
        components: {InstructionForm},
        methods: {
            onChange(row) {
                let Json = {id: row.id, status: row.status == 1 ? 2 : 1}
                changStatus(API.service.EDIT_STATUS, Json).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {
                    keyword: "",
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))
                API.service.GET_LIST({page: page || 1, type: 2, ...seachData}).then(res => {
                    this.data = res.data.data.data || res.data.data
                    this.pagination.total = res.data.data.total || 0
                    this.pagination.current = page || 1
                    this.loading = false
                })
            },
            onShowSizeChange(current, size) {
                this.pagination.pageSize = size
                this.getList(1)
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }
</style>
